export default __webpack_public_path__ + "static/SRL_OLP_EOI_July2023-1d092b3c12be8f7476c1d472bbcac725.pdf";